import React from "react";
import logo from "./logo.png";

export default function HomePage({ goTo }) {
  return (
     <div className="home-container">
      <div className="home-card glass-card">

        {/* Logo */}
        <div className="home-logo-wrap">
  <img src={logo} alt="Logo" className="home-logo" />
</div>

        {/* Boutons */}
        <div className="home-buttons">
          <button className="home-button" onClick={() => goTo("mesures")}>
            Mesures
          </button>

          <button className="home-button" onClick={() => goTo("tests")}>
            Tests
          </button>

          <button className="home-button" onClick={() => goTo("infos")}>
            Infos
          </button>

          <button className="home-button" onClick={() => goTo("archives")}>
            Archives
          </button>
        </div>

      </div>
    </div>
  );
}
